import { render } from "./ClickAndLearnAppPage.vue?vue&type=template&id=704d5bf5"
import script from "./ClickAndLearnAppPage.vue?vue&type=script&lang=js"
export * from "./ClickAndLearnAppPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ClickAndLearnAppPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "704d5bf5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('704d5bf5', __exports__)) {
    api.reload('704d5bf5', __exports__)
  }
  
  module.hot.accept("./ClickAndLearnAppPage.vue?vue&type=template&id=704d5bf5", () => {
    api.rerender('704d5bf5', render)
  })

}


export default __exports__